import { useEffect, useRef, useState } from 'react';
import useGetMostViewedOrMostRecentYMM from '@/home/RecommendedCarousels/hooks/useGetMostViewedOrMostRecentYMM';
import useGetRecommendedVehicles from '~/hooks/home/useGetRecommendedVehicles';
import AppliedFilters from '~/services/common/contracts/AppliedFilters';

export default function useGetUpgradeYourRideVehicles() {
  const { id, price = 0 } = useGetMostViewedOrMostRecentYMM() ?? {};
  const [filters, setFilters] = useState<Partial<AppliedFilters>>({});
  const vehicleIdRef = useRef(0);

  useEffect(() => {
    if (!id) return;

    setFilters({
      price: {
        min: Math.floor(price * 1.1) // Find slightly more expensive vehicle
      }
    });
    vehicleIdRef.current = id;
  }, [id, price]);

  const { vehicles, isLoaded } = useGetRecommendedVehicles(
    12,
    filters,
    vehicleIdRef.current
  );

  return { vehicles, isLoaded };
}
